import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { waLink } from "@/config";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  const { t } = useLang();
  return (
    <div data-testid="payment-cancel-page" className="pt-40 pb-32 max-w-2xl mx-auto px-6 text-center">
      <XCircle size={56} className="mx-auto text-[#8B8778]" strokeWidth={1} />
      <h1 className="font-serif-hc text-5xl mt-8 text-[#F5F2EA]">{t("booking.pay_cancel_title")}</h1>
      <p className="mt-5 text-[#A3A095] leading-relaxed">{t("booking.pay_cancel_msg")}</p>
      <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/reservar" className="hc-btn-primary" data-testid="payment-cancel-retry">{t("hero.cta_secondary")}</Link>
        <a href={waLink()} target="_blank" rel="noreferrer" className="hc-btn-wa">WhatsApp</a>
      </div>
    </div>
  );
}
